module.exports = __webpack_public_path__ + "static/img/yewuyingyong.0995588.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/yewuyingyong.png
// module id = HIf7
// module chunks = 1